export default "__VITE_ASSET__26066f46__"